export class Settings {
    year: number;
    month: number;
    viewType: string;
    dealerShipId: number;
    dealerGroupId: number;
    quarter: number;
    constructor (data) {
        this.year = data.year;
        this.month = data.month;
        this.viewType = data.viewType;
        this.dealerShipId = data.dealerShipId;
        this.dealerGroupId = data.dealerGroupId;
        this.quarter = data.quarter;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/setting.ts